<section class="container">
	<div class="py-8 sm:py-16">
		<div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-x-9">
			<h2
				class="order-2 col-span-2 pt-8 border-t sm:order-1 secondary-header sm:pt-0 sm:border-t-0"
			>
				Course Information
			</h2>

			<!-- Course Options  -->
			<div
				class="order-1 w-full pb-8 m-auto bg-white sm:order-2 sm:border sm:rounded-lg sm:px-6 sm:py-8"
				[ngClass]="{ 'sm:pt-16 sm:pb-16': !isFeatured() }"
			>
				<div class="pb-4 sm:pb-6">
					<p
						class="text-xl font-bold leading-6"
						[ngClass]="{ 'text-uc-clearing-100': clearingCourseEnabled() }"
					>
						{{ courseOptions().length }}
						@if (clearingCourseEnabled()) {
							<span> Clearing</span>
						}
						option<ng-container *ngIf="courseOptions().length > 1"
							>s</ng-container
						>
						available
					</p>
					<p class="mt-4 text-sm text-gray-500 sm:mt-3">
						Some courses vary and have tailored teaching options, select a
						course option below.
					</p>
				</div>
				<div class="relative w-full">
					<select
						(change)="onSelectedCourseOption($event)"
						class="truncate dropdown w-full px-3 pr-8 py-3.5 shadow-sm placeholder-gray-400 rounded-md focus:outline-none focus:ring-red-500 focus:border-blue-400 text-sm text-left cursor-pointer"
					>
						@for (option of courseOptions(); track option; let i = $index) {
							<option [value]="i">
								{{ option.study_mode | transformString: '_' }}
								|
								{{ option.duration }}
								|
								{{ option.start_date }}
								|
								{{ option.campus.name }}
							</option>
						}
					</select>
					<uc-arrow-down-svg customStyles="absolute right-1.5 bottom-4" />
				</div>
				<!-- CTA buttons -->
				<ng-content />
			</div>
			<!-- Course Details -->
			<div class="order-3 overflow-hidden bg-white sm:border sm:rounded-lg">
				<div
					class="hidden grid-cols-2 px-6 py-4 text-sm font-bold tracking-wider text-left text-gray-500 uppercase sm:grid-cols-12 sm:grid bg-gray-50"
				>
					<p class="sm:col-span-7">Course Details</p>
					<p>Information</p>
				</div>
				@if (courseOptions() && courseOptions()[selectedIndex()]; as option) {
					<uc-course-information-table-row
						providerDetail="Study Mode"
						[data]="option.study_mode | transformString: '_'"
					/>
					<uc-course-information-table-row
						providerDetail="Duration"
						[data]="option.duration"
					/>
					<uc-course-information-table-row
						providerDetail="Start Date"
						[data]="option.start_date"
					/>
					<uc-course-information-table-row
						providerDetail="Campus"
						[data]="option.campus.name"
						customStyles="border-b sm:border-b-0"
					/>
					<uc-course-information-table-row
						providerDetail="Course Address"
						[data]="formatAddress(option.campus.address)"
						customStyles="hidden sm:grid"
					/>
					<!-- Mobile only campus address -->
					<div class="mt-8 border-b sm:hidden">
						<div class="p-5 mb-8 border rounded-lg bg-gray-50">
							<div class="pb-6 mb-6 text-xl font-bold border-b">
								Course Address
							</div>
							<div>{{ option.campus.address.split(',')[0] }}</div>
							<div>{{ option.campus.address.split(',')[1] }}</div>
							<div>{{ option.campus.address.split(',')[2] }}</div>
							@if (
								option.campus.address.split(',')[3] !== ' United Kingdom'
							) {
								<div>{{ option.campus.address.split(',')[3] }}</div>
							}
						</div>
					</div>
				}
			</div>
		</div>
	</div>
</section>
